export var GameStatus;
(function (GameStatus) {
    GameStatus[GameStatus["Init"] = 0] = "Init";
    GameStatus[GameStatus["Gaming"] = 1] = "Gaming";
    GameStatus[GameStatus["GameOver"] = 2] = "GameOver";
    GameStatus[GameStatus["Win"] = 3] = "Win";
})(GameStatus || (GameStatus = {}));
// Six faces of the cube. Letters chosen so the set is visually distinct in logs/tests:
//   F = front (+Z), B = back (-Z), L = left (-X), R = right (+X), T = top (+Y), D = down/bottom (-Y).
export const FACES = ["F", "B", "L", "R", "T", "D"];
